import { render, staticRenderFns } from "./MembersReferralsList.vue?vue&type=template&id=4fdbeb30&"
import script from "./MembersReferralsList.vue?vue&type=script&lang=js&"
export * from "./MembersReferralsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports